import React from 'react';
import { motion } from 'framer-motion';
import { Edit2, Trash2, Clock } from 'lucide-react';
import { Service } from '../types';

interface ServiceCardProps {
  service: Service;
  onEdit: (service: Service) => void;
  onDelete: (id: string) => void;
}

export function ServiceCard({ service, onEdit, onDelete }: ServiceCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-300 p-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-medium text-base text-gray-900">{service.name_he}</h3>

        <div className="flex gap-1">
          <button
            onClick={() => onEdit(service)}
            className="p-1.5 text-gray-400 hover:text-indigo-600 active:scale-95 transition-all"
          >
            <Edit2 className="h-4 w-4" />
          </button>
          <button
            onClick={() => onDelete(service.id!)}
            className="p-1.5 text-gray-400 hover:text-red-600 active:scale-95 transition-all"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 text-sm text-gray-600">
          <Clock className="h-3.5 w-3.5" />
          <span>{service.duration} דק'</span>
        </div>
        <div className="text-base font-medium text-gray-900">
          ₪{service.price}
        </div>
      </div>
    </div>
  );
}
